export default __webpack_public_path__ + "static/Flexible-Access-1d5f03d373de29dfb9ed227a27b45fcd.webp";